import type { ApiTokensStore } from './interfaces'

export const actions = {
  setLoading (this: ApiTokensStore, payload: ApiTokensStore['loading']): void {
    this.loading = payload
  },
  setFilterUserId (this: ApiTokensStore, payload: ApiTokensStore['filterUserId']): void {
    this.filterUserId = payload
  },
  setFilterSearch (this: ApiTokensStore, payload: ApiTokensStore['filterSearch']): void {
    this.filterSearch = payload
  },
  setTokensPaginatedData (this: ApiTokensStore, payload: ApiTokensStore['tokensPaginatedData']): void {
    this.tokensPaginatedData = payload
  },
  setModalCreate (this: ApiTokensStore, payload: ApiTokensStore['isModalCreate']): void {
    this.isModalCreate = payload
  },
  setCreatedPlainTextToken (this: ApiTokensStore, payload: ApiTokensStore['createdPlainTextToken']): void {
    this.createdPlainTextToken = payload
  },
  setTokenToEdit (this: ApiTokensStore, payload: ApiTokensStore['tokenToEdit']): void {
    this.tokenToEdit = payload
  },
  setTokenToDelete (this: ApiTokensStore, payload: ApiTokensStore['tokenToDelete']): void {
    this.tokenToDelete = payload
  },
}
